<div *ngIf="(dashboardFacade.isChangeView$ | async) === false">
    <div
        *ngFor="let machine of machines"
        class="machine-container col-3 machine-status-title"
        [ngStyle]="{ color: machine.statusColor }"
    >
        <div class="machine-card" (click)="changeStatusModal(machine)">
            <div class="header flex-row">
                <div class="img">
                    <img
                        appImageSelector
                        alt="mt-status"
                        [imageType]="'dashboard-' + currentMachine"
                        [imageKey]="
                            machine.statusImage
                                ? machine.statusImage
                                : 'default'
                        "
                        (error)="handleImageError($event)"
                    />
                </div>

                <div class="description flex-col overflow">
                    <div
                        class="status truncated-title"
                        [ngbTooltip]="
                            machine.statusName.length > 15
                                ? machine.statusName
                                : ''
                        "
                    >
                        <span class="location-title">{{
                            machine.statusName
                        }}</span>
                    </div>
                    <div class="name">{{ machine.machineName }}</div>
                    <div class="date">
                        {{ machine.lastStatus | dateTimePresentation }}
                    </div>
                </div>
            </div>

            <div class="body flex-col overflow">
                <div class="truncated-text line-item">
                    <span class="label">
                        <strong
                            >{{ "operator" | lang | pascalcase }}:</strong
                        ></span
                    >
                    <span class="location-name value">{{
                        machine.operatorName || "-"
                    }}</span>
                </div>
                <div *ngIf="isHCM && isScoop" class="truncated-text line-item">
                    <span class="label">
                        <strong
                            >{{
                                machineValue?.traduction | lang | pascalcase
                            }}:</strong
                        ></span
                    >
                    <span class="location-name value">
                        {{
                            (machine?.firstEvent | dateTimePresentation) || "-"
                        }}
                    </span>
                </div>
                <div class="truncated-text line-item">
                    <span class="label">
                        <strong
                            >{{ "last-machine-status" | lang }}
                            {{
                                machineValue?.quantity | lang | lowercase
                            }}:</strong
                        >
                    </span>
                    <span class="location-name value">
                        {{
                            machine?.lastEvent === "-"
                                ? machine?.lastEvent
                                : (machine?.lastEvent | dateTimePresentation)
                        }}
                    </span>
                </div>
                <div
                    class="truncated-text line-item"
                    [ngStyle]="{
                        color: machine.isOutOfPark ? '#F05050' : 'unset'
                    }"
                >
                    <span class="label">
                        <strong style="color: black"
                            >{{ "last_location" | lang }}:</strong
                        >
                    </span>
                    <span
                        *ngIf="machine.lastZoneName"
                        [ngStyle]="{
                            color: machine.isOutOfPark ? '#F05050' : '',
                            'font-weight': machine.isOutOfPark ? '700' : ''
                        }"
                        [ngbTooltip]="getTooltipText(machine)"
                        class="location-name value"
                    >
                        {{ machine.lastZoneName }}
                    </span>
                    <span
                        *ngIf="!machine.lastZoneName"
                        class="location-name value"
                    >
                        {{ "m024" | lang }}
                    </span>
                </div>

                <div class="truncated-text line-item">
                    <span class="label">
                        <strong
                            >{{
                                machine.countMeasure === 0 ||
                                machine.countMeasure > 1
                                    ? (machineValue?.traduction.plural
                                      | lang
                                      | pascalcase)
                                    : (machineValue?.traduction.singular
                                      | lang
                                      | pascalcase)
                            }}:</strong
                        >
                    </span>
                    <span class="location-name value">
                        {{ machine.countMeasure || "0" }}
                    </span>
                </div>
                <div class="truncated-text line-item">
                    <span class="label">
                        <strong
                            >{{
                                machineValue?.unit | lang | pascalcase
                            }}:</strong
                        >
                    </span>
                    <span class="location-name value">
                        {{ machine.totalMeasure || "0" }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<div
    *ngIf="(dashboardFacade.isChangeView$ | async) === true"
    [ngClass]="{ 'fade-in-up': true }"
>
    <app-machine-status-table
        [collection]="machines"
        [currentMachine]="currentMachine"
    ></app-machine-status-table>
</div>
